import { TextEditor } from 'handsontable/editors/textEditor'
import { createRoot } from 'react-dom/client'
import { ReactMultiSelect } from './components/single-select'

export class AutoDropdownEditor extends TextEditor {
  constructor(props) {
    super(props)

    this.localdata = {
      selected: [],
    }
  }

  prepare(...args) {
    super.prepare(...args)
  }

  open() {
    this.hot.unlisten()
    this.parent = document.getElementById('reactSingle')
    if (!this.parent) {
      this.TEXTAREA_REACT = document.createElement('div')
      this.TEXTAREA_REACT.setAttribute('id', 'reactSingle')
      this.TEXTAREA_PARENT.appendChild(this.TEXTAREA_REACT)
      this.TEXTAREA_PARENT.className += ' react'
      this.parent = this.TEXTAREA_PARENT
    }

    const checked = []
    const currentlyChecked = this.originalValue
      ? this.originalValue.split(this.cellProperties.divider)
      : []

    this.cellProperties.source.forEach(item => {
      if (currentlyChecked.includes(item)) {
        checked.push(item)
      }
    })

    const options = this.cellProperties.source.map(item => {
      return { value: item, label: item }
    })

    const selected = checked.map(item => {
      return { value: item, label: item }
    })

    this.localdata.selected = selected

    this.textareaStyle = this.TEXTAREA.style
    this.textareaStyle.width = 0
    this.textareaStyle.height = 0
    this.textareaStyle.minWidth = 0
    this.textareaStyle.maxWidth = 0

    this.textareaReactStyle = this.TEXTAREA_REACT.style
    this.textareaReactStyle.top = 2
    this.textareaReactStyle.position = 'absolute'
    this.textareaReactStyle.width = '100%'
    this.textareaReactStyle.height = 350

    this.TEXTAREA_PARENT.style.width = `${this.TD.getClientRects()[0]?.width}px`

    const self = this

    this.handleClose = nextLine => {
      self.finishEditing()
      self.close()
      self.TD?.focus()

      if (nextLine === 'TAB') {
        self.instance.selectCell(self.row, self.col + 1)
      } else if (!nextLine) {
        self.instance.selectCell(self.row, self.col)
      }
    }

    this.updateData = data => {
      self.localdata = data
    }

    if (!this.root) {
      this.root = createRoot(this.parent)
    }

    this.root.render(
      <ReactMultiSelect
        data={this.localdata}
        updateData={this.updateData}
        options={options}
        isSingle={true}
        selected={selected}
        row={this.row}
        close={this.handleClose}
        parent={this.TD}
      />,
    )

    this.refreshDimensions() // need it instantly, to prevent https://github.com/handsontable/handsontable/issues/348
    this.showEditableElement()

    super.open()
  }

  getValue() {
    const val = this.localdata && this.localdata.selected.value
    return val
  }

  setValue(value) {
    this.TEXTAREA.value = value
  }

  focus() {
    // don't
  }

  finishEditing(restoreOriginalValue, ctrlDown, callback) {
    super.finishEditing(restoreOriginalValue, ctrlDown, callback)

    if (this.root) {
      this.root.unmount()
      this.root = null
    }
  }

  close(...args) {
    if (!this.instance.rootElement) {
      return
    }

    super.close(...args)
  }

  createElements() {
    super.createElements()
    this.TEXTAREA_REACT = document.createElement('div')
    this.TEXTAREA_REACT.setAttribute('id', 'reactSingle')
    this.TEXTAREA_PARENT.appendChild(this.TEXTAREA_REACT)
    this.TEXTAREA_PARENT.className += ' react'
  }
}
